import React, { useCallback, useEffect, useState } from "react"
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
  CForm,
  CFormInput,
} from "@coreui/react"
import {
  Flex,
  Form,
  Input,
  Typography,
  DatePicker,
  Button,
  Switch,
  Checkbox,
  Select,
} from "antd"
import { useDispatch, useSelector } from "react-redux"
import {
  addClent,
  getClientsList,
  setAddClientModal,
  getClubs,
} from "src/store/Slices/ClientsSlice"
import MaskedInput from "antd-mask-input"
import "./style.css"
import { openNotification } from "src/components/helpers/notification"
import dayjs from "dayjs"
import TextArea from "antd/es/input/TextArea"
import { sendMailing, sendMailingLoading } from "src/store/Slices/MailingsSlice"
import { runes } from "runes2"
import { EmojiKeyboard } from "reactjs-emoji-keyboard"
import InputEmoji from "react-input-emoji"

const MailModal = ({
  visible,
  setVisible,
  clientInfo,
  setPage,
  setPageSize,
  clientsList,
  setClientMarkedList,
  allActive,
  setAllActive,
}) => {
  const dispatch = useDispatch()
  const dateFormatList = ["YYYY-MM-DD"]
  const clients = useSelector((state) => state.ClientsSlice.clientsList)

  const mailLoading = useSelector(
    (state) => state.MailingsSlice.sendMailingLoading,
  )

  const [message, setMessage] = useState("")
  const [header, setHeader] = useState("")
  const [sendTime, setSendTime] = useState()
  const [activeInput, setActiveInput] = useState(true)
  const [cur, setCur] = useState()
  const [showPicker, setShowPicker] = useState(false)
  const [clubId, setClubId] = useState()

  const clubs = useSelector((state) => state.ClientsSlice.clubs)
  useEffect(() => {}, [clientInfo])
  const onBlur = (e) => {
    setCur(e?.target?.selectionStart)
  }
  const handleEmojiClick = useCallback(
    (emoji) => {
      if (activeInput === false) {
        setMessage(message.slice(0, cur) + emoji.character + message.slice(cur))
        setCur(cur + emoji.character.length)
      } else {
        setHeader(header.slice(0, cur) + emoji.character + header.slice(cur))
        setCur(cur + emoji.character.length)
      }
    },
    [cur],
  )
  const style = {
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.3)",
    borderRadius: "10px",
    right: "500px",
  }
  
  const onClickSubmit = () => {
  if (!header.trim()) {
    openNotification({
      type: "error",
      message: "Заголовок не может быть пустым",
    })
    return
  }

  if (!message.trim()) {
    openNotification({
      type: "error",
      message: "Текст сообщения не может быть пустым",
    })
    return
  }

  // Функция формирования поля с клубами
  const getClubField = () => {
    // Если клуб не выбран - отправляем null
    if (!clubId || clubId.length === 0) {
      return { clubId: null }
    }
    
    // Если выбран 1 клуб
    if (clubId.length === 1) {
      return { clubId: clubId[0] }
    }
    
    // Если выбрано несколько клубов
    return { clubs: clubId }
  }

  let payload = {
    header: header.trim(),
    body: message.trim(),
    sendDate: sendTime || null,
    typeId: 3,
    sentAll: allActive,
  }

  if (allActive) {
    let clubIdValue;
    
    payload = {
      ...payload,
      users: [],
      usersToExclude: Array.isArray(clientInfo) ? clientInfo : [],
      clubs: clubId, 
    }
  } else {
    payload = {
      ...payload,
      users: Array.isArray(clientInfo) ? clientInfo : [],
      usersToExclude: [],
      clubId: clubId
    }
  }

  console.log('Отправляемый payload:', payload);

  // Исправленный dispatch - только один unwrap()
  dispatch(sendMailing(payload))
    .unwrap()
    .then((response) => {
      openNotification({
        type: "success",
        message: "Рассылка успешно создана",
      })
      setVisible({ open: false })
      setPage(1)
      setPageSize(20)
      setMessage("")
      setHeader("")
      setSendTime(null)
      setClubId(null)
      // Сбрасываем выбранных клиентов если нужно
      if (setClientMarkedList) {
        setClientMarkedList([])
      }
      if (setAllActive) {
        setAllActive(false)
      }
    })
    .catch((error) => {
      console.error("Send mailing error:", error)
      openNotification({
        type: "error",
        message: "Ошибка при создании рассылки",
        description: error.message || "Проверьте заполненные поля",
      })
    })
}
  const deleteFromList = (index) => {
    var NewMarkedId = clientInfo.filter((_, i) => i !== index)
    setClientMarkedList(NewMarkedId)
  }

  const handleUserClick = () => {
    if (activeInput === false) {
      setMessage(message?.slice(0, cur) + "{username}" + message?.slice(cur))
      setCur(cur + 1)
    } else {
      setHeader(header.slice(0, cur) + " {username} " + header.slice(cur))
      setCur(cur + 1)
    }
  }

  const closeModal = () => {
    setVisible({ open: false, flag: "" })
    setMessage("")
    setHeader("")
    setSendTime()
    setActiveInput(true)
    setCur()
    setShowPicker(false)
  }

  useEffect(() => {}, [clientInfo])
  return (
    <>
      {window.innerWidth >= 768 ? (
        <CModal
          size='xl'
          alignment='center'
          visible={visible.open}
          aria-labelledby='VerticallyCenteredExample'
          onClose={() => {
            closeModal()
          }}
          keyboard={true}
        >
          <CModalHeader>
            <CModalTitle id='VerticallyCenteredExample'>
              {visible.flag === "add"
                ? "Добавить клиента"
                : "Создание рассылки"}
            </CModalTitle>
          </CModalHeader>
          <CModalBody
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row", gap: "60px" }}>
              <Flex vertical gap={16}>
                <div style={{ width: "650px" }}>
                  <Typography.Title level={5}>Заголовок</Typography.Title>
                  <Input
                    defaultValue=''
                    value={header}
                    onChange={(e) => {
                      setHeader(e.currentTarget.value)
                    }}
                    onClick={() => setActiveInput(true)}
                    onBlur={(e) => onBlur(e)}
                    count={{
                      show: true,
                      max: 50,
                      //@ts-ignore
                      strategy: (txt) => runes(txt).length,
                      //@ts-ignore
                      exceedFormatter: (txt, { max }) =>
                        runes(txt).slice(0, max).join(""),
                    }}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Основной текст</Typography.Title>
                  <TextArea
                    rows={10}
                    count={{
                      show: true,
                      max: 205,
                      //@ts-ignore
                      strategy: (txt) => runes(txt).length,
                      //@ts-ignore
                      exceedFormatter: (txt, { max }) =>
                        runes(txt).slice(0, max).join(""),
                    }}
                    defaultValue=''
                    value={message}
                    onChange={(e) => {
                      setMessage(e.currentTarget.value)
                    }}
                    onClick={() => setActiveInput(false)}
                    onBlur={(e) => onBlur(e)}
                  />
                </div>
                {allActive && (
                  <div>
                    <Typography.Title level={5}>Клуб</Typography.Title>
                    <Select
                      style={{ width: "100%" }}
                      placeholder='Выбрать'
                      onClick={() => {
                        dispatch(getClubs())
                      }}
                      value={clubId}
                      onChange={(e) => {
                        setClubId(e) 
                      }}
                      options={clubs?.data?.value || []}
                      mode='multiple' 
                    />
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: "30px",
                      cursor: "pointer",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title='Смайлики'
                    onClick={() => setShowPicker(!showPicker)}
                  >
                    ☺
                  </div>
                  <Button
                    style={{ alignItems: "center", justifyContent: "center" }}
                    onClick={() => handleUserClick()}
                  >
                    Вставить ФИО
                  </Button>
                </div>
                <div>
                  <Typography.Title level={5}>Время отправки</Typography.Title>
                  <DatePicker
                    showTime
                    format={"YYYY-MM-DD HH:mm"}
                    onChange={(date, dateString) => {
                      setSendTime(
                        dateString
                          ? dayjs(dateString).format("YYYY-MM-DDTHH:mm:ss")
                          : null,
                      )
                    }}
                    style={{ width: "100%" }}
                    placement={"topRight"}
                    defaultValue={dayjs(sendTime)}
                  />
                </div>
              </Flex>
              {showPicker ? (
                <EmojiKeyboard
                  height={420}
                  width={300}
                  theme='light'
                  searchLabel='Procurar emoji'
                  containerStyle={style}
                  searchDisabled={false}
                  onEmojiSelect={(emoji) => handleEmojiClick(emoji)}
                  categoryDisabled={false}
                />
              ) : (
                <div style={{ width: "300px", height: "450px" }}>
                  <span>
                    {allActive ? "Исключенные клиенты" : "Выбранные клиенты"}
                  </span>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "10px",
                      boxShadow: "0 0 8px 0 rgba(215, 83, 182, 0.5)",
                      padding: "5px",
                      height: "420px",
                      width: "300px",
                      overflowY: "auto",
                    }}
                  >
                    {clientInfo?.length > 0 ? (
                      clientInfo?.map((client, index) => (
                        <>
                          <div
                            style={{
                              textAlign: "center",
                              margin: "0 auto",
                              width: "250px",
                              borderRadius: "10px",
                              boxShadow: "0 0 6px 0 rgba(215, 83, 182, 0.5)",
                              padding: "5px",
                              marginBottom: "7px",
                              marginTop: "7px",
                              transition: "all 0.2s ease",
                              opacity: "1",
                              position: "relative",
                            }}
                            key={index}
                          >
                            № {client}
                            <Button
                              onClick={() => deleteFromList(index)}
                              shape='circle'
                              style={{
                                opacity: 0.3,
                                position: "absolute",
                                right: "0px",
                                top: "1px",
                              }}
                            >
                              ✕
                            </Button>
                          </div>
                        </>
                      ))
                    ) : (
                      <p style={{ margin: "0 auto", color: "rgba(0,0,0,0.5)" }}>
                        <em>Клиенты не выбраны</em>
                      </p>
                    )}
                  </div>
                  {/* <div style={{display: 'flex', flexDirection:'column', alignItems:'center', marginTop:'10px'}}>
                        <p>Добавить всех пользователей</p>
                        <Switch/>
                    </div> */}
                </div>
              )}
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton
              onClick={() => {
                closeModal()
              }}
              className='text-light'
              color='secondary'
            >
              Закрыть
            </CButton>
            <CButton
              onClick={onClickSubmit}
              className='text-light'
              disabled={
                mailLoading ||
                (clientInfo.length === 0 && allActive === false) ||
                message === "" ||
                header === ""
                  ? true
                  : false
              }
            >
              {visible.flag === "add" ? "Добавить" : "Отправить"}
            </CButton>
          </CModalFooter>
        </CModal>
      ) : (
        <CModal
          alignment='center'
          visible={visible.open}
          aria-labelledby='VerticallyCenteredExample'
          onClose={() => {
            closeModal()
          }}
          keyboard={true}
        >
          <CModalHeader>
            <CModalTitle id='VerticallyCenteredExample'>
              {visible.flag === "add"
                ? "Добавить клиента"
                : "Создание рассылки"}
            </CModalTitle>
          </CModalHeader>
          <CModalBody
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row", gap: "60px" }}>
              <Flex vertical gap={16}>
                <Typography.Title level={5}>Заголовок</Typography.Title>
                <Input
                  defaultValue=''
                  value={header}
                  onChange={(e) => {
                    setHeader(e.currentTarget.value)
                  }}
                  onClick={() => setActiveInput(true)}
                  onBlur={(e) => onBlur(e)}
                  count={{
                    show: true,
                    max: 50,
                    //@ts-ignore
                    strategy: (txt) => runes(txt).length,
                    //@ts-ignore
                    exceedFormatter: (txt, { max }) =>
                      runes(txt).slice(0, max).join(""),
                  }}
                />
                <div>
                  <Typography.Title level={5}>Основной текст</Typography.Title>
                  <TextArea
                    rows={10}
                    count={{
                      show: true,
                      max: 205,
                      //@ts-ignore
                      strategy: (txt) => runes(txt).length,
                      //@ts-ignore
                      exceedFormatter: (txt, { max }) =>
                        runes(txt).slice(0, max).join(""),
                    }}
                    defaultValue=''
                    value={message}
                    onChange={(e) => {
                      setMessage(e.currentTarget.value)
                    }}
                    onClick={() => setActiveInput(false)}
                    onBlur={(e) => onBlur(e)}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Button
                    style={{ alignItems: "center", justifyContent: "center" }}
                    onClick={() => handleUserClick()}
                  >
                    Вставить ФИО
                  </Button>
                </div>

                <div>
                  <Typography.Title level={5}>Время отправки</Typography.Title>
                  <DatePicker
                    format={"YYYY-MM-DD HH:mm:ss"}
                    onChange={(date, dateString) => {
                      setSendTime(
                        dateString
                          ? dayjs(dateString).format("YYYY-MM-DDTHH:mm:ss")
                          : null,
                      )
                    }}
                    style={{ width: "100%" }}
                    placement={"topRight"}
                    defaultValue={sendTime && dayjs(sendTime, dateFormatList)}
                  />
                </div>
              </Flex>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton
              onClick={() => {
                closeModal()
              }}
              className='text-light'
              color='secondary'
            >
              Закрыть
            </CButton>
            <CButton onClick={onClickSubmit} className='text-light'>
              {visible.flag === "add" ? "Добавить" : "Отправить"}
            </CButton>
          </CModalFooter>
        </CModal>
      )}
    </>
  )
}

export default MailModal
